import {CartDetails} from '~/components/cart';
import {Drawer} from './Drawer.client';
import {useEffect} from 'react';
import {preventBodyScroll} from '~/lib';

export function CartDrawer({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  useEffect(() => {
    preventBodyScroll(isOpen);
  }, [isOpen]);

  return (
    <Drawer
      classNamePanel={
        'max-w-[583px] bg-gray-200 overflow-hidden h-auto flex flex-col'
      }
      open={isOpen}
      onClose={onClose}
      heading="Cart"
      openFrom="right"
      belowNavigation
      hideHeader
    >
      <CartDetails layout="drawer" onClose={onClose} />
    </Drawer>
  );
}
